import { createContext, useContext } from 'react';

import type { FocusRegistry } from './focus-registry';

export interface FocusManagerContextValue {
  readonly registry: FocusRegistry;
}

export const FocusManagerContext = createContext<FocusManagerContextValue | null>(null);

export function useFocusManagerContext(): FocusManagerContextValue {
  const ctx = useContext(FocusManagerContext);
  if (!ctx) {
    throw new Error(
      '[FocusManager] useFocusManagerContext must be used within FocusManagerProvider.',
    );
  }
  return ctx;
}
